import type { ErrorsLocale } from "@/locales/fr/errors";

import { MoveSiteToHouseholderErrorCode } from "@/domains/site/site.errors";

const moveSiteCodes: Record<MoveSiteToHouseholderErrorCode, string> = {
  [MoveSiteToHouseholderErrorCode.INVALID_SEGMENT]:
    "This site's business segment does not allow it to be converted to a householder site.",
  [MoveSiteToHouseholderErrorCode.SITE_HAS_PLANNED_APPOINTMENT]:
    "This site has a planned appointment and cannot be converted to a householder site.",
  [MoveSiteToHouseholderErrorCode.SITE_HAS_NO_SUBSCRIBER]:
    "A subscriber must exist on the site site before it can be converted to a householder site.",
  [MoveSiteToHouseholderErrorCode.SITE_HAS_NO_LAYOUT]:
    "This site's layout type must be specified before it can be converted to a householder site.",
  [MoveSiteToHouseholderErrorCode.PROFESSIONAL_LAYOUT_WITHOUT_SMALL_COMPANY]:
    "Professional site layout can only be converted to a householder site if the subscriber is a small company.",
};

const codes = { ...moveSiteCodes };

const errors: ErrorsLocale = {
  errors: {
    codes,
    unknownCode: "An error occurred. Please try again later. Error code: {code}",
    invalidType: "Invalid field",
    invalidTypeReceivedUndefined: "Mandadory",
    invalidLiteral: "Invalid value",
    unrecognizedKeys: "Unrecognized keys",
    invalidUnion: "Invalid value",
    invalidUnionDiscriminator: "Invalid discriminator value. Expected {options}",
    invalidEnumValue: "Invalid option. Expected: {options}",
    invalidArguments: "Invalid function parameters",
    invalidReturnType: "Invalid function value returned",
    invalidDate: "Invalid date",
    custom: "Invalid value",
    invalidIntersectionTypes: "Intersection results could not be merged",
    notMultipleOf: "The number must be a multiple of {multipleOf}",
    notFinite: "The number must be finite",
    invalidString: {
      email: "Invalid email",
      url: "Invalid URL",
      uuid: "Invalid UUID",
      cuid: "Invalid CUID",
      regex: "Invalid value",
      datetime: "Invalid date and time",
      startsWith: "Invalid value: must start with {startsWith}",
      endsWith: "Invalid value: must end with {endsWith}",
    },
    tooSmall: {
      array: {
        exact: "Insert {minimum} element | Insert {minimum} elements",
        inclusive: "Insert at least {minimum} element | Insert at least {minimum} elements",
        notInclusive: "Insert more than {minimum} element | Insert more than {minimum} elements",
      },
      string: {
        exact: "The length must be of {minimum} character | The length must be of {minimum} characters",
        inclusive: "Minimum length {minimum} character | Minimum length {minimum} characters",
        notInclusive: "Insert more than {minimum} character | Insert more than {minimum} characters",
      },
      number: {
        exact: "The value must be {minimum}",
        inclusive: "Insert a value greater or equal to {minimum}",
        notInclusive: "Insert a value greater than {minimum}",
      },
      set: {
        exact: "Invalid value",
        inclusive: "Invalid value",
        notInclusive: "Invalid value",
      },
      date: {
        exact: "The date must be {minimum}",
        inclusive: "The date must be later or equal to {minimum}",
        notInclusive: "The date must be later than {minimum}",
      },
    },
    tooBig: {
      array: {
        exact: "Insert {maximum} element | Insert {maximum} elements",
        inclusive: "Insert at most {maximum} element | Insert at most {maximum} elements",
        notInclusive: "Insert less than {maximum} element | Insert less than {maximum} elements",
      },
      string: {
        exact: "The length must be of {maximum} character | The length must be of {maximum} characters",
        inclusive: "Maximum length {maximum} character | Maximum length {maximum} characters",
        notInclusive: "Insert less than {maximum} character | Insert less than {maximum} characters",
      },
      number: {
        exact: "The value must be {maximum}",
        inclusive: "Insert a value less or equal to {maximum}",
        notInclusive: "Insert a value less than {maximum}",
      },
      set: {
        exact: "Invalid value",
        inclusive: "Invalid value",
        notInclusive: "Invalid value",
      },
      date: {
        exact: "The date must be {maximum}",
        inclusive: "The date must be earlier or equal to {maximum}",
        notInclusive: "The date must be earlier than {maximum}",
      },
    },
  },
};

export default errors;
